<template>
  <div class="grid gap-[12px]">
    <div class="text-[16px] font-semibold mb-[8px] mt-[8px]">
      {{ in18[prefix === 'physical_address' ? 'attribute_physical_address' : 'attribute_company_address'] }}
    </div>

    <!-- First Row (1 Column, 100%) -->
    <div class="w-full">
      <!-- Country -->
      <div class="relative">
        <select
            :id="prefix + 'country_id'"
            v-model="address.country_id"
            :disabled="inProgress"
            :class="[errors[prefix + '.country_id'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', address.country_id === null ? 'text-gray' : '' ]"
            class="appearance-none h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all placeholder-gray w-full"
            :name="prefix + 'country_id'"
            @input="clearValidationError(prefix + '.country_id')">
          <option :value="null" disabled selected class="text-gray">
            {{ in18['attribute_address_country'] }}
          </option>
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ country.title }}
          </option>
        </select>
        <span class="pointer-events-none absolute inset-y-0 right-[16px] flex items-center">
          <img
              alt=""
              src="/shop/images/dropdown-toggle-arrow.svg"
              class="h-5 w-5 text-gray-400 transform-all  duration-300"
              aria-hidden="true"
          />
        </span>
      </div>
      <validation-error :errors="errors[prefix + '.country_id']"/>
    </div>

    <!-- Second Row (2 Columns, 50% each) -->
    <div class="grid grid-cols-2 gap-4">
      <!-- City -->
      <div class="relative">
        <label
            class="leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
            :class="[address.city ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
            :id="prefix + '.city'"
        >
          {{ in18['attribute_address_city'] }}
        </label>
        <input
            :id="prefix + '.city'"
            v-model="address.city"
            :class="[errors[prefix + '.city'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', address.city && 'pt-[30px]']"
            class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all w-full"
            type="text"
            @input="clearValidationError(prefix + '.city')"
            :disabled="inProgress"
        />
        <validation-error :errors="errors[prefix + '.city']"/>
      </div>

      <!-- Region -->
      <div class="relative">
        <label
            class="leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
            :class="[address.region ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
            :for="prefix + '.region'"
        >
          {{ in18['attribute_address_region'] }}
        </label>
        <input
            :id="prefix + '.region'"
            v-model="address.region"
            :class="[errors[prefix + '.region'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', address.region && 'pt-[30px]']"
            class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all w-full"
            type="text"
            @input="clearValidationError(prefix + '.region')"
            :disabled="inProgress"
        />
        <validation-error :errors="errors[prefix + '.region']"/>
      </div>
    </div>

    <!-- Third Row (2 Columns, 50% each) -->
    <div class="grid grid-cols-2 gap-4">
      <!-- Address -->
      <div class="relative">
        <label
            class="leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
            :class="[address.address ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
            :for="prefix + '.address'"
        >
          {{ in18['attribute_address_address'] }}
        </label>
        <input
            :id="prefix + '.address'"
            v-model="address.address"
            :class="[errors[prefix + '.address'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', address.address && 'pt-[30px]']"
            class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all w-full"
            type="text"
            @input="clearValidationError(prefix + '.address')"
            :disabled="inProgress"
        />
        <validation-error :errors="errors[prefix + '.address']"/>
      </div>

      <!-- ZIP -->
      <div class="relative">
        <label
            class="leading-[14px] font-light absolute left-[17px] top-[10px] transition-all pointer-events-none"
            :class="[address.zip ? 'top-[10px] text-[8px] text-lime-green' : 'top-[19px] text-[16px] text-gray']"
            :for="prefix + '.zip'"
        >
          {{ in18['attribute_company_zip'] }}
        </label>
        <input
            :id="prefix + '.zip'"
            v-model="address.zip"
            :class="[errors[prefix + '.zip'] ? 'border-[#eb2635]' : 'focus-within:border-lime-green border-light-gray/25', address.zip && 'pt-[30px]']"
            class="h-[52px] text-[16px] p-[16px] font-light leading-[20px] text-charcoal border rounded-[8px] outline-none transition-all w-full"
            type="text"
            @input="clearValidationError(prefix + '.zip')"
            :disabled="inProgress"
        />
        <validation-error :errors="errors[prefix + '.zip']"/>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationError from "../../features/ValidationError.vue";

export default {
  components: {
    ValidationError,
  },
  props:      {
    address:              Object,
    errors:               Object,
    in18:                 Object,
    countries:            Array,
    prefix:               String,
    clearValidationError: Function,
    inProgress:           Boolean,
  },
};
</script>
